import { getTranslate } from 'legacy-src/utilities/i18n'
import React from 'react'

import { ButtonLink } from '@/legacy-src/components/ui/button'

import { useMessages } from '../../contexts/messages-context/messages-context'
import useUser from '../../hooks/useUser'

type Props = { therapistUserId: number }

const SendSessionRequest: React.FC<Props> = ({ therapistUserId }) => {
  const { t } = getTranslate()
  const { conversations } = useMessages()
  const { user } = useUser()

  const conversationId = conversations.find((conv) => conv.uniqueName === `conv-c:${user.id}-t:${therapistUserId}`)?.sid

  if (!conversationId) return null

  return (
    <div className="mt-5 flex flex-wrap items-center justify-between gap-2 tablet:mb-0">
      <h2 className="mb-0 text-xl">{t('component.calendar.nothingFits')}</h2>
      <ButtonLink
        href={{
          pathname: `/messages/${conversationId}`,
          query: { message: t('component.converstaion.requestSessionMessage') },
        }}
        variant="inline"
        className="normal-case"
      >
        {t('component.calendar.sendMessage')}
      </ButtonLink>
    </div>
  )
}

export default SendSessionRequest
